@let documentType = docType();
@let docName = doc().name;
<div class="document">
  <mat-icon class="material-icons-outlined {{ documentType }}">{{ docsConfig[documentType] }}</mat-icon>
  <div class="document__info">
    <h6 class="name" [matTooltip]="docName">{{ docName | truncate: 25: true }}</h6>
    <span class="size">{{ size() | number:'1.0-2' }} MB</span>
  </div>

  <mat-icon
    class="material-icons-outlined download"
    (click)="downloadDocument()">
    download
  </mat-icon>
</div>